export const cacheKeys = {
  userLanguage: 'user.language'
};

export const headerTranslation = {
  about: 7409,
  title: 4033,
  new_case: 3028,
  new_report: 8195,
  reports_company: 5330,
  reports_saved: 7827,
  user_profile: 4011,
  dashboards: 6779,
  reports: 3537,
  logout: 7428,
  menu: 7429,
  search: 5537,
  codetable_administration: 8268,
  user_administration: 5241,
  role_administration: 8038,
  dashboards_and_reports: 9083,
  manage_dashboard: 9088,
  manage_dashboards_title: 8718,
  manage_company_reports_title: 8857,
  manage_messages_title: 8457,
  messages_to_users: 9089,
  translations: 9084,
  text_configuration_title: 8556,
  texts: 9090,
  code_descriptions: 9341,
  refresh_cache_title: 7859,
  my_downloads_title: 7870,
  import_title: 7891,
  other_tools: 9085,
  regenerate_aggregated_environmental_data: 7883,
  regenerate_aggregated_risk_data: 7882,
  help: 3062,
  notifications: 8197,
  messages: 3632,
  manage_surveys: 7092,
  administration: 8384,
  tools: 8390,
  feedback: 8406,
  saved_reports_company: 8788,
  saved_dashboards: 9016,
  manage_favourites: 9108,
  code_mapping_administration: 9243,
  manage_import_sets: 9242,
  manage_code_mappings: 9276,
  external_urls: 9403,
  external_url: 9430,
  external_url_groups: 9431,
  experience_transfer_administration: 9655,
  subscriber_groups_administration: 9498,
  user_members_administration: 9613,
  experience_transfer_configuration: 9619,
  configure_operations_transfer: 9670,
  ai_chat_title: 9723,
  ai_chat_hover_text: 9730,
  message_too_many_requests: 9775
};

export type LayoutTranslation = {
  readonly [T in keyof typeof layoutTranslation]: string
};

export const layoutTranslation = {
  about_title: 718,
  about_close: 4329,
  about_copyrights: 7444,
  about_info: 5554,
  refresh_cache_title: 7859,
  refresh_cache_description: 7858,
  refresh_cache_submit_button: 7859,
  refresh_cache_cancel: 7860,
  refresh_cache_success: 7861,
  regenerate_aggregated_environmental_title: 7883,
  regenerate_aggregated_risk_title: 7882,
  regenerate_aggregated_tables_title: 9424,
  regenerate_aggregated_environmental_description: 7887,
  regenerate_aggregated_environmental_info: 9773,
  regenerate_aggregated_risk_description: 7886,
  regenerate_aggregated_tables_description: 9425,
  regenerate_aggregated_tables_info: 9426,
  regenerate_aggregated_submit_button: 7888,
  regenerate_aggregated_cancel: 7860,
  regenerate_aggregated_enviromental_success: 7885,
  regenerate_aggregated_risk_success: 7884,
  regenerate_aggregated_tables_success: 9427,

  notification_toast_title: 8264,
  notification_toast_subtitle: 8263,
  notification_toast_link: 8262,

  my_downloads_title: 7870,
  notification_banner_title: 8170,
  notification_banner_button: 8169,
  import_title: 7891,
  unread_messages: 8227,
  mark_as_read: 8223,
  mark_as_unread: 8233
};

export const footerTranslation = {
  contact_information: 7422,
  any_problems: 7423,
  your_location: 7424,
  your_user_group: 7425,
  your_unit: 7427,
  about_synergi: 7409,
  language: 8023
};

export const messagesToUserTranslation = {
  messages: 3632,
  no_messages: 5923,
  mark_as_read: 8223,
  read_messages: 8230,
  unread_messages: 8227,
  no_unread_messages: 8231,
  mark_as_unread: 8233,
  no_read_messages: 8234,
  message_date: 8235,
  manage_messages_button: 9342
};

export const messageStatusOptions = {
  unread: 1,
  read: 2
};
